import React, { Component } from "react";
// Style
import './myBlogStyle.css';
// Components
import { BlogIViewerr } from "../../Components/myBlogComponents/blogViewer";
import MainFooter from "../../Components/MainFooter/MainFooter";
import { MainHeaderr } from "../../Components/mainHeader/HeaderMain";
import { BlogSide } from "../../Components/myBlogComponents/BlogSideBar/BlogSide";



class MyBlog extends Component{

    constructor(){
        super();
        document.addEventListener("scroll" , ()=>{

        });
        window.addEventListener("DOMContentLoaded" , ()=>{

        });

        this.state = {
            myBeruf : "",
        }
    }



    render(){
        return(
            <div>

            <MainHeaderr activeBlog={"NavListItemAtive"} />

                <div className="Body d-flex justify-content-between align-items-top">
                    <div className="BlogIViewer" > <BlogIViewerr /> </div>
                    <div className="BlogSideBar" > <BlogSide /> </div>
                </div>

                <div>
                    <MainFooter />
                </div>
            </div>
        );
    }


}


export default MyBlog;